import type { Dayjs } from "dayjs";
import { useCallback, useState } from "react";
import { Severity } from "type";
import { getUserType } from "util/auth";
import dayjs from "dayjs";
import downloadTireReportApi from "../api/downloadTireReportApi";
import type { TireReportParams } from "../types";
import { INVALID_DATE } from "../constants";

/**
 * Custom hooks to download tire usage reports as CSV.
 * @param showAlert アラート表示
 */
export default function useTireReportDownload(showAlert: (msg: string, severity?: Severity) => void) {
  const [reportKind, setReportKind] = useState<number>();
  const [target, setTarget] = useState<number>();
  const [dateFrom, setDateFrom] = useState<Dayjs | null>(dayjs().startOf("month"));
  const [dateTo, setDateTo] = useState<Dayjs | null>(dayjs());
  const [companyCd, setCompanyCd] = useState<string>("");
  const [storeCd, setStoreCd] = useState<string>("");

  // const [storeName, setStoreName] = useState<string>("");
  // const [reportType, setReportType] = useState<string>("");
  // const [startDate, setStartDate] = useState<Dayjs | null>(null);
  // const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDownload = async () => {
    if (!dateFrom || !dateTo) {
      showAlert("開始日と終了日を指定してください", "error");
      return;
    }
    if (dateFrom.format("YYYY-MM-DD") === INVALID_DATE || dateTo.format("YYYY-MM-DD") === INVALID_DATE) {
      showAlert("開始日と終了日を正しく指定してください", "error");
      return;
    }
    if (reportKind === undefined) {
      showAlert("レポートの種類を選択してください", "error");
      return;
    }
    let tar = target;
    if (!target) {
      const userType = getUserType();
      // 店舗が選択されていないとき
      switch (userType) {
        case "C0001":
          tar = 4; // 本部が対象
          break;
        case "C0006":
          tar = 3; // 企業が対象
          break;
        case "C0002":
          tar = 1; // 店舗が対象
          break;
        case "C0003":
          tar = 2; // 得意先が対象
          break;
        default:
          tar = 1; // デフォルトは店舗が対象
          break;
      }
    }

    setIsLoading(true);
    try {
      // 1をデフォルトタイプとして
      const safeReportKind = reportKind ?? 1;
      const params: TireReportParams = {
        reportKind: safeReportKind,
        target: tar as number,
        dateFrom: dateFrom.format("YYYY-MM-DD"),
        dateTo: dateTo.format("YYYY-MM-DD"),
        companyCd,
        storeCd,
      };
      await downloadTireReportApi(params, showAlert);

      // const blob = await downloadTireReportApi(params);
      // const url = window.URL.createObjectURL(blob);
      // const a = document.createElement("a");
      // a.href = url;
      // a.download = `tire-report_${startDate}_${endDate}.csv`;
      // a.click();
      // window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert("CSVのダウンロードに失敗しました");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    // storeName,
    // setStoreName,
    // reportType,
    // setReportType,
    // startDate,
    // setStartDate,
    // endDate,
    // setEndDate,

    reportKind,
    setReportKind,
    setTarget,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    companyCd,
    setCompanyCd,
    storeCd,
    setStoreCd,
    handleDownload,
    isLoading,
  };
}
